import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const UserManagementPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" gutterBottom>
          User Management
        </Typography>
        <Typography variant="body1">
          Manage system users and permissions
        </Typography>
      </Box>
    </Container>
  );
};

export default UserManagementPage; 